import styled from 'styled-components';

export const InsuranceCompanyListWrap = styled.div`
    display: block;
    width: 100%;
    overflow: auto;
`;
